import { render } from "./CardContact.vue?vue&type=template&id=1f6eeefd"
import script from "./CardContact.vue?vue&type=script&lang=js"
export * from "./CardContact.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__